import brightsign from '@upshow/brightsign';
import Logger from '../Logger'
import * as UP from '../Upshow';
import { getModel } from '../utils/models';

const HwFeatureService = {

    isSupported: function isSupported(feature) {
        if (typeof HwFeatureService.getFeatureMap()[feature] === "undefined") {
            Logger.log("HwFeatureService", `Feature '${feature}' support status is undefined`);
            return false;
        }

        return HwFeatureService.getFeatureMap()[feature];
    },

    supportJukin: function supportJukin(isYoutube) {
        const model = getModel();

        if (model === 'xi6') return false;

        const isLowEndDevice = model === 'xumo' || model === 'brightsign';

        if (isLowEndDevice) return isYoutube && HwFeatureService.isSupported('media-channel');

        return HwFeatureService.isSupported('media-channel');
    },
    supportMediaChannelVod: function supportMediaChannelVod(isYoutube) {
        const model = getModel();
        const isLowEndDevice = model === 'xumo' || model === 'brightsign';

        if (!isLowEndDevice) return false;
        return HwFeatureService.isSupported('media-channel') && !isYoutube;
    },
    getFeatureMap: function getFeatureMap() {
        const { model } = UP.getDeviceInfo();
        if (model.startsWith("AF")) {
            return {
                "cta-animations": false,
                "video-tile": false,
                "tile-flip": true,
                "blur-background": false,
                "caption_flip": false,
                "tile-flip-with-media": false,
                "pre-render": false,
                "video-in-media-layout": false,
                "media_no_crop": false,
                "overscan": false,
                "upshownow_videos": false,
                "upshownow_intro": false,
                "background_music": false,
                "epg-marketing-button": false,
                "should-sign-org-tc": false,
                "show-exit-app-pop-up": false,
                "apply-comcast-styles": false,
                "spotlight": false,
                "media-channel": false,
                "application": false,

                "social": false,
                "trivia": false,
                "upshownow": false,
                "vistar": false,
                "watchtowin": false,
                "fixed-content": false,
                "wifi-management": false,
            };
        } else if (model.toLowerCase().startsWith("brightsign")) {
            return {
                "cta-animations": true,
                "video-tile": true,
                "tile-flip": true,
                "blur-background": true,
                "caption_flip": true,
                "tile-flip-with-media": true,
                "pre-render": true,
                "video-in-media-layout": true,
                "media_no_crop": true,
                "overscan": true,
                "upshownow_videos": true,
                "upshownow_intro": true,
                "background_music": true, //true for testing purposes
                "epg-marketing-button": true,
                "should-sign-org-tc": false,
                "show-exit-app-pop-up": false,
                "apply-comcast-styles": false,
                "spotlight": true,
                "media-channel": true,
                "application": true,

                "social": true,
                "trivia": true,
                "upshownow": true,
                "vistar": true,
                "watchtowin": true,
                "fixed-content": true,
                "wifi-management": true,
            };
        } else if (model.toLowerCase().startsWith("xumo")) {
            return {
                "cta-animations": false,
                "video-tile": false,
                "tile-flip": false,
                "blur-background": false,
                "caption_flip": false,
                "tile-flip-with-media": false,
                "pre-render": false,
                "video-in-media-layout": false,
                "media_no_crop": false,
                "overscan": false,
                "upshownow_videos": false,
                "upshownow_intro": false,
                "background_music": false,
                "epg-marketing-button": true,
                "should-sign-org-tc": true,
                "show-exit-app-pop-up": true,
                "apply-comcast-styles": true,
                "spotlight": true,
                "media-channel": true,
                "application": false,

                "social": false,
                "trivia": false,
                "upshownow": false,
                "vistar": false,
                "watchtowin": false,
                "fixed-content": false,
                "wifi-management": false,
            };
        } else if (model.toLocaleLowerCase().startsWith("xi6") ||
            model.toLocaleLowerCase().startsWith("xid") ||
            model.toLocaleLowerCase().startsWith("xg2v2")) {
            return {
                "cta-animations": false,
                "video-tile": false,
                "tile-flip": false,
                "blur-background": false,
                "caption_flip": false,
                "tile-flip-with-media": false,
                "pre-render": false,
                "video-in-media-layout": false,
                "media_no_crop": false,
                "overscan": false,
                "upshownow_videos": false,
                "upshownow_intro": false,
                "background_music": false,
                "epg-marketing-button": false,
                "should-sign-org-tc": false,
                "show-exit-app-pop-up": true,
                "apply-comcast-styles": true,
                "spotlight": false,
                "media-channel": false,
                "application": false,

                "social": false,
                "trivia": false,
                "upshownow": false,
                "vistar": false,
                "watchtowin": false,
                "fixed-content": false,
                "wifi-management": false,
            };
        } else if (model.toLowerCase().startsWith("lgwebos") ||
            model.toLowerCase().startsWith("samsungtizen") ||
            model.toLowerCase().startsWith("androidtv") ||
            model.toLowerCase().startsWith("firetv")) {
            return {
                "cta-animations": true,
                "video-tile": true,
                "tile-flip": true,
                "blur-background": true,
                "caption_flip": true,
                "tile-flip-with-media": true,
                "pre-render": true,
                "video-in-media-layout": true,
                "media_no_crop": true,
                "overscan": true,
                "upshownow_videos": true,
                "upshownow_intro": true,
                "background_music": true,
                "epg-marketing-button": true,
                "should-sign-org-tc": false,
                "show-exit-app-pop-up": true,
                "apply-comcast-styles": false,
                "spotlight": true,
                "media-channel": true,
                "application": true,

                "social": true,
                "trivia": true,
                "upshownow": true,
                "vistar": true,
                "watchtowin": true,
                "fixed-content": true,
                "wifi-management": false,
            };
        }

        return {
            "cta-animations": true,
            "video-tile": true,
            "tile-flip": true,
            "blur-background": true,
            "caption_flip": true,
            "tile-flip-with-media": true,
            "pre-render": true,
            "video-in-media-layout": true,
            "media_no_crop": true,
            "overscan": true,
            "upshownow_videos": true,
            "upshownow_intro": true,
            "background_music": true,
            "epg-marketing-button": true,
            "should-sign-org-tc": false,
            "show-exit-app-pop-up": false,
            "apply-comcast-styles": false,
            "spotlight": true,
            "media-channel": true,
            "application": true,
            "social": true,
            "trivia": true,
            "upshownow": true,
            "vistar": true,
            "watchtowin": true,
            "fixed-content": true,
            "wifi-management": false,
        };
    }
};

export default HwFeatureService;
